<template>
  <div class="legal-notice-overlay">
    <div class="legal-notice-content container bg-white p-4 p-md-5 rounded shadow-lg">
      <button @click="$emit('close')" class="btn-close" aria-label="Fermer"></button>

      <h1 class="display-5 mb-4">Mentions Légales</h1>

      <p>Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique,
        il est précisé aux utilisateurs du site <strong>BebeBulle.fr</strong> l'identité des différents intervenants
        dans le cadre de sa réalisation et de son suivi.</p>

      <hr class="my-4">

      <h3 class="mt-4">Édition du site</h3>
      <p>Le présent site, accessible à l'URL <a href="https://bebulle.com/">https://bebulle.com/</a>, est édité par :
      </p>
      <p><strong>Micro-crèche Bébé Bulle</strong>, société [À COMPLÉTER : Forme juridique], inscrite au R.C.S. de [À
        COMPLÉTER : Ville] sous le numéro [À COMPLÉTER : Numéro RCS], dont le siège social est situé au <strong>3 bis
          rue Georges Nerisson, 65430 Soues, France</strong>.</p>

      <h3 class="mt-4">Hébergement</h3>
      <p>Le site est hébergé par la société [À COMPLÉTER : Nom de l'hébergeur].</p>

      <h3 class="mt-4">Responsables de la publication</h3>
      <p>Les Directrices de la publication du site sont <strong>Madame PEREZ Sophie</strong> et <strong>Madame BAUDRY
        Nathalie</strong>.</p>

      <h3 class="mt-4">Nous contacter</h3>
      <ul>
        <li><strong>Par téléphone</strong> : +33 5 62 94 84 85</li>
        <li><strong>Par email</strong> : [À COMPLÉTER : Adresse email de contact]</li>
        <li><strong>Par courrier</strong> : 3 bis rue Georges Nerisson, 65430 Soues, France</li>
      </ul>

      <h3 class="mt-4">Données personnelles</h3>
      <p>Les données personnelles collectées via le formulaire de pré-inscription sont uniquement destinées à un usage
        interne, dans le but de répondre à vos demandes. En aucun cas ces données ne seront cédées ou vendues à des
        tiers. Vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données qui
        vous concernent.</p>

      <h3 class="mt-4">Propriété intellectuelle</h3>
      <p>L'ensemble de ce site (contenus, textes, images, logos) est la propriété exclusive de la société Micro-crèche
        Bébé Bulle.</p>

      <div class="text-center mt-5">
        <button @click="$emit('close')" class="btn btn-primary">Retour au site</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Define the "close" event that the component can emit
defineEmits(["close"]);
</script>

<style scoped>
.legal-notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1050; /* Above the navbar */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.legal-notice-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.btn-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>
